import { render, staticRenderFns } from "./AcademyPublicEventCard.vue?vue&type=template&id=acb82116&scoped=true"
import script from "./AcademyPublicEventCard.vue?vue&type=script&lang=js"
export * from "./AcademyPublicEventCard.vue?vue&type=script&lang=js"
import style0 from "./AcademyPublicEventCard.vue?vue&type=style&index=0&id=acb82116&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acb82116",
  null
  
)

export default component.exports